export const SEARCH_AUTOSUGGEST_MAX_RESULT_DISPLAY = 5;